import type { Cart as NostoCart } from '@nosto/types';

import { useNostoApi } from './useNostoApi';

/**
 * Sends cart data to the Nosto.
 * @param cart - The optional cart data to be sent to the Nosto API.
 */
export function useNostoCart(cart?: NostoCart) {
  useNostoApi(async (api) => {
    const apiCall = api.defaultSession();

    if (cart) {
      apiCall.setCart(cart);
    }

    // eslint-disable-next-line prettier/prettier
    return apiCall
      .viewCart()
      .setPlacements(api.placements.getPlacements())
      .load();
  }, 'CART');
}
